// Dependencies
import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';

// Primereact imports
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './registration.scss';

// Redux
import { connect } from 'react-redux';
import FinancialService from '../../../redux/services/finance';
import { getRegistrationPaymentList } from '../../../redux/actions/finance';

// Utils
import { PAYMENT_CHANNEL_CREDIT_CARD, PAYMENT_CHANNEL_MB, PAYMENT_CHANNEL_MBWAY, PAYMENT_STATE_PAYED } from '../../../common/constants';
import { PAYMENT_STATE_WAITING_PAYMENT } from '../../../common/constants';
import { PAYMENT_CHANNEL_BANK_TRANSFER } from '../../../common/constants';
import { PAYMENT_TYPE_REGISTRATION } from '../../../common/constants';

class RegistrationPaymentListComponent extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
    }

    componentDidMount() {
        this.props.getRegistrationPaymentList(this.props.registrationRef);
    }

    downloadInvoice(invoiceRef) {
        FinancialService.generateInvoicePdf(invoiceRef)
        .then((response) => {
            window.open(response.output.pdfUrl, '_blank');
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("finance.messages.error"), life: 3000 });
        });
    }
  
    priceBodyTemplate(rowData) {
        return rowData.price + " €";
    }
  
    dateBodyTemplate(rowData, column) {
        return rowData[column] !== undefined && rowData[column] !== null ? rowData[column].replace('T',' ') : "";
    }
  
    stateBodyTemplate(rowData) {
        if(rowData.state === PAYMENT_STATE_PAYED) {
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("finance.form.payed")}</span>;
        }
        else if(rowData.state === PAYMENT_STATE_WAITING_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("finance.form.waiting-payment")}</span>;
        }
        else {
        return <span className={'state-badge'} style={{background: '#C63737', color: '#FFFFFF'}}>{this.props.t("finance.form.cancelled")}</span>;
        }
    }
  
    paymentChannelBodyTemplate(rowData) {
        if(rowData.channel === PAYMENT_CHANNEL_MB) {
            return this.props.t("finance.form.payment-channel-mb");
        }
        else if(rowData.channel === PAYMENT_CHANNEL_MBWAY) {
            return this.props.t("finance.form.payment-channel-mbway");
        }
        else if(rowData.channel === PAYMENT_CHANNEL_CREDIT_CARD) {
            return this.props.t("finance.form.payment-channel-credit-card");
        }
        else if(rowData.channel === PAYMENT_CHANNEL_BANK_TRANSFER   ) {
            return this.props.t("finance.form.payment-channel-bank-transfer");
        }
        else {
            return this.props.t("finance.form.payment-channel-direct-debit");
        }
    }
  
    paymentTypeBodyTemplate(rowData) {
        if(rowData.type === PAYMENT_TYPE_REGISTRATION) {
            return this.props.t("finance.form.payment-type-registration");
        }
        else {
            return this.props.t("finance.form.payment-type-enrollment");
        }
    }

    invoiceDownloadBodyTemplate(rowData) {
        return <Button icon="pi pi-download" onClick={() => this.downloadInvoice(rowData.invoiceRef)} />;
    }

    render() {

       return (
            <div>
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className="col-12">                   
                        <div id="data-container" className="card mgt-20">
                        {
                            this.props.payments !== null ? 
                                <div className="grid">
                                    <div className="col-12">
                                        <DataTable value={this.props.payments} paginator className="p-datatable-gridlines" showGridlines rows={10} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("finance.messages.no-payments")}>
                                            <Column field="type" header={this.props.t("finance.form.type-header")} body={(data) => this.paymentTypeBodyTemplate(data)} style={{ minWidth: '12rem' }}  />
                                            <Column field="price" header={this.props.t("finance.form.price-header")} body={(data) => this.priceBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                            <Column field="creationDate" header={this.props.t("finance.form.creation-date-header")} body={(data) => this.dateBodyTemplate(data, 'creationDate')} style={{ minWidth: '12rem' }} />
                                            <Column field="paymentDate" header={this.props.t("finance.form.payment-date-header")} body={(data) => this.dateBodyTemplate(data, 'paymentDate')} style={{ minWidth: '12rem' }} />
                                            <Column field="channel" header={this.props.t("finance.form.channel-header")} body={(data) => this.paymentChannelBodyTemplate(data)} style={{ minWidth: '12rem' }}  />
                                            <Column field="state" header={this.props.t("finance.form.state-header")} body={(data) => this.stateBodyTemplate(data)} style={{ minWidth: '10rem' }}  />
                                            <Column field="invoiceRef" header={this.props.t("finance.form.invoice-header")} body={(data) => this.invoiceDownloadBodyTemplate(data)} style={{ minWidth: '8rem' }}  />
                                        </DataTable>
                                    </div>
                                </div>
                                : null
                        }
                        </div>
                    </div>
                </div>
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
            registrationRef: state.authentication.registrationRef,
            payments: state.finance.payments
    } 
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      getRegistrationPaymentList: (registrationRef) => { dispatch(getRegistrationPaymentList(registrationRef)) }
    }
  };

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(RegistrationPaymentListComponent));